import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { CierreMes} from './CierreMes.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'CierreMes',
        component: CierreMes,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CierreMes'
        } 
    }
];

@NgModule({
    declarations: [
        CierreMes
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        CierreMes
    ],
    bootstrap: [CierreMes]
})

export class CierreMesModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CierreMes/CierreMes.module.ts